import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'

const ColouredTile = (props) => {
  const {
    borderColor, boxProps, children, color,
  } = props

  return (
    <Box
      alignItems="center"
      border="1px solid"
      borderColor={borderColor || color}
      borderRadius="5px"
      color={color}
      flexShrink="0"
      fontSize="xxsmall"
      height={38}
      justifyContent="center"
      letterSpacing="1px"
      style={{ textTransform: 'uppercase' }}
      width={84}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

ColouredTile.propTypes = {
  borderColor: PropTypes.string,
  boxProps: PropTypes.object,
  children: PropTypes.node,
  color: PropTypes.string,
}

export default ColouredTile
